
document.getElementById('burgerBtn').addEventListener('click', function(){
  document.getElementById('mainMenu').classList.toggle('open');
});
document.querySelectorAll('#mainMenu a').forEach(function(a){
  a.addEventListener('click', function(){ document.getElementById('mainMenu').classList.remove('open'); });
});


// Free Consultation button opens the Tidio chat on the live site.
// (In this mockup Tidio is not installed, so it falls back to the consultation section.)
document.getElementById('tidioBtn').addEventListener('click', function(e){
  if (window.tidioChatApi) { e.preventDefault(); if (window.tidioChatApi.show) window.tidioChatApi.show(); window.tidioChatApi.open(); }
});
// Hide the floating Tidio bubble on this homepage only: the Free Consultation
// button above already opens the same chat, so the bubble just covers it.
// Event-based (fires whenever Tidio becomes ready) plus 60s polling backup:
// polling alone can miss a slow Tidio load and leave the old bubble visible.
(function(){
  function hideTidio(){
    if (window.tidioChatApi && window.tidioChatApi.hide) { window.tidioChatApi.hide(); return true; }
    return false;
  }
  if (hideTidio()) return;
  document.addEventListener('tidioChatReady', hideTidio);
  var tries = 0;
  (function tryHide(){
    if (hideTidio()) return;
    if (++tries < 120) setTimeout(tryHide, 500);
  })();
})();


(function(){
  var cards = document.querySelectorAll('#revView .rev-card');
  var dotsWrap = document.getElementById('revDots');
  var cur = 0, timer;
  cards.forEach(function(_, i){
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Review ' + (i+1));
    if (i === 0) b.className = 'on';
    b.addEventListener('click', function(){ show(i); restart(); });
    dotsWrap.appendChild(b);
  });
  var dots = dotsWrap.querySelectorAll('button');
  function show(i){
    cards[cur].classList.remove('on'); dots[cur].classList.remove('on');
    cur = i;
    cards[cur].classList.add('on'); dots[cur].classList.add('on');
  }
  function restart(){ clearInterval(timer); timer = setInterval(function(){ show((cur+1)%cards.length); }, 5000); }
  restart();
})();


document.querySelectorAll('#sb-homepage-wrap .sol-toggle').forEach(function(btn){
  btn.addEventListener('click', function(){
    var card = btn.closest('.sol-card');
    var open = card.classList.toggle('open');
    btn.textContent = open ? 'Hide products ⌃' : 'See products ⌄';
  });
});


// hero photo carousel rotator
  var phs = document.querySelectorAll('#heroPhotos .ph');
  var phDotsBox = document.getElementById('phDots');
  var phCur = 0, phTimer = null;
  phs.forEach(function(_, i){
    var d = document.createElement('button');
    d.setAttribute('aria-label','Photo ' + (i+1));
    if(i===0) d.className='on';
    d.onclick = function(){ phShow(i); phRestart(); };
    phDotsBox.appendChild(d);
  });
  var phDots = phDotsBox.querySelectorAll('button');
  function phShow(i){
    phs[phCur].classList.remove('on'); phDots[phCur].classList.remove('on');
    phCur = i;
    phs[phCur].classList.add('on'); phDots[phCur].classList.add('on');
  }
  function phRestart(){ clearInterval(phTimer); phTimer = setInterval(function(){ phShow((phCur+1)%phs.length); }, 3000); }
  phRestart();


// steps: ONE frame — picture AND text change together (fade, no sliding)
  var stepsData = [
    {img:'hero-ai/media-generation-step-1-order-laptop-gap-0-0ac7e3f1-a85b-4b25-a773-63d902c99b10.webp',
     title:'Place Your Order',
     text:'Your impression kit is ready to be dispatched today or the next business day.'},
    {img:'hero-ai/media-generation-step-2-impressions-0-09e2b89a-711e-4687-bc35-761b36290a17.webp',
     title:'Take Your Impressions',
     text:'Just a few minutes from your couch: follow the easy guide or video, send your impressions back with the prepaid label — and we take care of the rest.'},
    {img:'hero-ai/media-generation-step-3-smile-0-c6fc3705-b14f-4aaa-8617-93199c0bb94c.webp',
     title:'Get Your Smile',
     text:'Your smile is handcrafted in just 3–7 business days, depending on your appliance. Need it sooner? Rush service is available.'}
  ];
  var svImgs = document.querySelectorAll('#stepView .sv-img');
  var svTitle = document.getElementById('svTitle'), svText = document.getElementById('svText');
  var svStepLabel = document.getElementById('svStepLabel');
  var svStepWords = ['Step 1','Step 2','Step 3'];
  var svCur = 0, svTimer = null;
  function svShow(i){
    svCur = i;
    svImgs.forEach(function(im, j){ im.classList.toggle('on', j===i); });
    svStepLabel.textContent = svStepWords[i];
    svTitle.textContent = stepsData[i].title;
    svText.textContent = stepsData[i].text;
    document.querySelectorAll('#svDots button').forEach(function(d, j){ d.classList.toggle('on', j===i); });
    var card = document.getElementById('stepView');
    card.classList.remove('sv-fade'); void card.offsetWidth; card.classList.add('sv-fade');
  }
  document.querySelectorAll('#svDots button').forEach(function(d, j){ d.onclick = function(){ svShow(j); svRestart(); }; });
  function svRestart(){ clearInterval(svTimer); svTimer = setInterval(function(){ svShow((svCur+1)%stepsData.length); }, 4500); }
  svRestart();


// picker toggles
  document.querySelectorAll('[data-pick]').forEach(function(group){
    group.querySelectorAll('button').forEach(function(btn){
      btn.onclick = function(){
        group.querySelectorAll('button').forEach(function(b){ b.classList.remove('on'); });
        btn.classList.add('on');
      };
    });
  });

(function(){

document.getElementById('burgerBtnD').addEventListener('click', function(){
  document.getElementById('mainMenuD').classList.toggle('open');
});
document.querySelectorAll('#mainMenuD a').forEach(function(a){
  a.addEventListener('click', function(){ document.getElementById('mainMenuD').classList.remove('open'); });
});

})();
(function(){

// Free Consultation button opens the Tidio chat on the live site.
// (In this mockup Tidio is not installed, so it falls back to the consultation section.)
document.getElementById('tidioBtnD').addEventListener('click', function(e){
  if (window.tidioChatApi) { e.preventDefault(); if (window.tidioChatApi.show) window.tidioChatApi.show(); window.tidioChatApi.open(); }
});
// Hide the floating Tidio bubble on this homepage only: the Free Consultation
// button above already opens the same chat, so the bubble just covers it.
// Event-based (fires whenever Tidio becomes ready) plus 60s polling backup:
// polling alone can miss a slow Tidio load and leave the old bubble visible.
(function(){
  function hideTidio(){
    if (window.tidioChatApi && window.tidioChatApi.hide) { window.tidioChatApi.hide(); return true; }
    return false;
  }
  if (hideTidio()) return;
  document.addEventListener('tidioChatReady', hideTidio);
  var tries = 0;
  (function tryHide(){
    if (hideTidio()) return;
    if (++tries < 120) setTimeout(tryHide, 500);
  })();
})();

})();
(function(){

(function(){
  var cards = document.querySelectorAll('#revViewD .rev-card');
  var dotsWrap = document.getElementById('revDotsD');
  var cur = 0, timer;
  cards.forEach(function(_, i){
    var b = document.createElement('button');
    b.setAttribute('aria-label', 'Review ' + (i+1));
    if (i === 0) b.className = 'on';
    b.addEventListener('click', function(){ show(i); restart(); });
    dotsWrap.appendChild(b);
  });
  var dots = dotsWrap.querySelectorAll('button');
  function show(i){
    cards[cur].classList.remove('on'); dots[cur].classList.remove('on');
    cur = i;
    cards[cur].classList.add('on'); dots[cur].classList.add('on');
  }
  function restart(){ clearInterval(timer); timer = setInterval(function(){ show((cur+1)%cards.length); }, 5000); }
  restart();
})();

})();
(function(){

document.querySelectorAll('#sb-homepage-wrap-d .sol-toggle').forEach(function(btn){
  btn.addEventListener('click', function(){
    var card = btn.closest('.sol-card');
    var open = card.classList.toggle('open');
    btn.textContent = open ? 'Hide products ⌃' : 'See products ⌄';
  });
});

})();
(function(){

// hero photo carousel rotator
  var phs = document.querySelectorAll('#heroPhotosD .ph');
  var phDotsBox = document.getElementById('phDotsD');
  var phCur = 0, phTimer = null;
  phs.forEach(function(_, i){
    var d = document.createElement('button');
    d.setAttribute('aria-label','Photo ' + (i+1));
    if(i===0) d.className='on';
    d.onclick = function(){ phShow(i); phRestart(); };
    phDotsBox.appendChild(d);
  });
  var phDots = phDotsBox.querySelectorAll('button');
  function phShow(i){
    phs[phCur].classList.remove('on'); phDots[phCur].classList.remove('on');
    phCur = i;
    phs[phCur].classList.add('on'); phDots[phCur].classList.add('on');
  }
  function phRestart(){ clearInterval(phTimer); phTimer = setInterval(function(){ phShow((phCur+1)%phs.length); }, 3000); }
  phRestart();

})();
(function(){

// steps: ONE frame — picture AND text change together (fade, no sliding)
  var stepsData = [
    {img:'hero-ai/media-generation-step-1-order-laptop-gap-0-0ac7e3f1-a85b-4b25-a773-63d902c99b10.webp',
     title:'Place Your Order',
     text:'Your impression kit is ready to be dispatched today or the next business day.'},
    {img:'hero-ai/media-generation-step-2-impressions-0-09e2b89a-711e-4687-bc35-761b36290a17.webp',
     title:'Take Your Impressions',
     text:'Just a few minutes from your couch: follow the easy guide or video, send your impressions back with the prepaid label — and we take care of the rest.'},
    {img:'hero-ai/media-generation-step-3-smile-0-c6fc3705-b14f-4aaa-8617-93199c0bb94c.webp',
     title:'Get Your Smile',
     text:'Your smile is handcrafted in just 3–7 business days, depending on your appliance. Need it sooner? Rush service is available.'}
  ];
  var svImgs = document.querySelectorAll('#stepViewD .sv-img');
  var svTitle = document.getElementById('svTitleD'), svText = document.getElementById('svTextD');
  var svStepLabel = document.getElementById('svStepLabelD');
  var svStepWords = ['Step 1','Step 2','Step 3'];
  var svCur = 0, svTimer = null;
  function svShow(i){
    svCur = i;
    svImgs.forEach(function(im, j){ im.classList.toggle('on', j===i); });
    svStepLabel.textContent = svStepWords[i];
    svTitle.textContent = stepsData[i].title;
    svText.textContent = stepsData[i].text;
    document.querySelectorAll('#svDotsD button').forEach(function(d, j){ d.classList.toggle('on', j===i); });
    var card = document.getElementById('stepViewD');
    card.classList.remove('sv-fade'); void card.offsetWidth; card.classList.add('sv-fade');
  }
  document.querySelectorAll('#svDotsD button').forEach(function(d, j){ d.onclick = function(){ svShow(j); svRestart(); }; });
  function svRestart(){ clearInterval(svTimer); svTimer = setInterval(function(){ svShow((svCur+1)%stepsData.length); }, 4500); }
  svRestart();

})();
(function(){

// picker toggles
  document.querySelectorAll('[data-pick]').forEach(function(group){
    group.querySelectorAll('button').forEach(function(btn){
      btn.onclick = function(){
        group.querySelectorAll('button').forEach(function(b){ b.classList.remove('on'); });
        btn.classList.add('on');
      };
    });
  });

})();